import React, { useState } from "react";
import "./Approach.css";
// import IconImage1 from "../../img/Asset-1.png";
import IconImage2 from "../../img/Asset-2.png";
import IconImage3 from "../../img/Asset-3.png";
import IconImage4 from "../../img/Asset-04.png";
import IconImage5 from "../../img/Asset-05.png";

export default function Approach() {
  const [activeSection, setActiveSection] = useState("Web Development");

  const sections = [
    {
      id: "01/",
      title: "Web Development",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ligula sagittis dignissim tortor sollicitudin accumsan.",
      bulletPoints: [
        "Understanding Client Objectives",
        "Strategic Planning",
        "User-Centric Design",
      ],
      img: IconImage2,
    },
    {
      id: "02/",
      title: "Mobile Development",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ligula sagittis dignissim tortor sollicitudin accumsan.",
      bulletPoints: [
        "User-Centric Research",
        "Platform Selection Stack",
        "Agile Development Process",
      ],
      img: IconImage3,
    },
    {
      id: "03/",
      title: "Cloud Services",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ligula sagittis dignissim tortor sollicitudin accumsan.",
      bulletPoints: [
        "Comprehensive Cloud Strategy",
        "Scalable Infrastructure Design",
        "Security and Compliance",
      ],
      img: IconImage4,
    },
    {
      id: "04/",
      title: "Test Automation",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ligula sagittis dignissim tortor sollicitudin accumsan.",
      bulletPoints: [
        "Comprehensive Test Strategy",
        "Test Execution & Reporting",
        "Maintenance & Improvement",
      ],
      img: IconImage5,
    },
  ];

  const currentSection = sections.find(
    (section) => section.title === activeSection
  ) || sections[0]; // Fallback to the first section

  return (
    <section className="approach">
      <div className="heading">
        <div className="left-info">
          <h2>OUR APPROACH</h2>
          <button className="discover-btn-a">DISCOVER NOW</button>
        </div>
        <div className="right-info">
          <p>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolor
            quaerat rerum eos saepe neque commodi maiores nesciunt veniam
            doloremque reiciendis? Iusto commodi hic placeat rerum nulla
            repudiandae est dolorum quis!
          </p>
        </div>
      </div>
      <div className="horizontal-line-a">
        <hr />
      </div>
      <div className="approach-container">
        {/* Left Section: Menu */}
        <div className="approach-menu">
          <ul>
            {sections.map((item) => (
              <li
                key={item.title}
                className={activeSection === item.title ? "active" : ""}
                onClick={() => setActiveSection(item.title)}
              >
                {item.title}
              </li>
            ))}
          </ul>
        </div>

        {/* Middle Section: Vertical Line and Image */}
        <div className="middle-section">
          <div className="vertical-line-a"></div>
          <img
            src={currentSection.img}
            alt="icon"
            className="approach-image"
          />
        </div>

        {/* Right Section: Description */}
        <div className="approach-content">
          <p className="id-section">{currentSection.id}</p>
          <h3>{currentSection.title}</h3>
          <p>{currentSection.description}</p>
          <ul className="bullet-points">
            {currentSection.bulletPoints.map((point, index) => (
              <li key={index}>{point}</li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
